"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdResponsive = _interopRequireDefault(require("cccisd-responsive"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Component = function Component(props) {
  var question = props.question,
    elementStyle = props.elementStyle,
    items = props.items,
    currentItemType = props.currentItemType,
    currentItemContent = props.currentItemContent,
    currentItemId = props.currentItemId,
    settings = props.settings,
    field = props.field;
  var wrapperRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var adjustHeight = (0, _react.useCallback)(function () {
    var bottomBar = document.getElementById('cccisd-flow-bottom-bar');
    if (!wrapperRef.current || !bottomBar) {
      return;
    }
    var wrapperRect = wrapperRef.current.getBoundingClientRect();
    var barRect = bottomBar.getBoundingClientRect();
    var barStyles = window.getComputedStyle(bottomBar);
    setHeight(barRect.top - wrapperRect.top - parseInt(barStyles.marginTop, 10) - (elementStyle === 'bubble' ? 38 : 0));
  }, []);
  var measuredRef = (0, _react.useCallback)(function (node) {
    wrapperRef.current = node;
    adjustHeight();
  }, []);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', adjustHeight);
    return function () {
      window.removeEventListener('resize', adjustHeight);
    };
  }, []);
  var renderAccordion = function renderAccordion() {
    return settings.items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: item.id
      }, items[index], item.id === currentItemId && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content
      }, currentItemContent));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdResponsive["default"], {
    stylesheet: _style["default"],
    render: function render(_ref) {
      var width = _ref.width;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: [_cccisdSurveyCommon.commonStyle.lastRow, _cccisdSurveyCommon.commonStyle.elementWrapper, _cccisdSurveyCommon.commonStyle[elementStyle]].join(' ')
      }, question && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em'
        }
      }, question), width > 600 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper,
        ref: measuredRef,
        style: {
          minHeight: "".concat(height, "px")
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].items
      }, items), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].content, _style["default"][settings.background], currentItemType ? _style["default"][currentItemType.contentType] : '')
      }, /*#__PURE__*/_react["default"].createElement("div", null, currentItemContent))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].accordion
      }, renderAccordion()), field.error && field.touched && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger",
        style: {
          margin: '1em 0 0'
        }
      }, field.error));
    }
  });
};
Component.propTypes = {
  question: _propTypes["default"].node,
  elementStyle: _propTypes["default"].string,
  items: _propTypes["default"].array,
  currentItemType: _propTypes["default"].object,
  currentItemContent: _propTypes["default"].node,
  currentItemId: _propTypes["default"].number,
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object
};
var _default = exports["default"] = Component;